<mbs-modal
  #modal
  class="premium-support-activated-modal"
  [isCustomModal]="true"
  [showFooter]="true"
  [showHeader]="false">
  <div modal-body>
    <div class="text-center pt-2 px-3 pb-3">
      <span class="premium-activated__icon fa fa-check-circle d-block lh-1 mb-4 text-success"></span>
      <h3 class="mt-0">
        {{ 'shared:licenses.buyPremiumSupportModal.activatedTitle' | i18next }}
      </h3>
      <div class="text-muted">
        {{ 'shared:licenses.buyPremiumSupportModal.activatedSubtitle' | i18next }}
      </div>
    </div>
  </div>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      (click)="close()">
      {{ 'shared:licenses.buyPremiumSupportModal.gotIt' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
